import script from "./CobranzaAccountsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CobranzaAccountsList.vue?vue&type=script&setup=true&lang=js"

import "./CobranzaAccountsList.vue?vue&type=style&index=0&id=12d50ff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d50ff0"]])

export default __exports__